var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.313 4.063V2.188c0-1.036.839-1.876 1.875-1.876h1.874M14.688 4.063V2.188c0-1.036-.84-1.876-1.876-1.876h-1.874M.313 10.938v1.874c0 1.036.839 1.876 1.875 1.876h1.874M14.688 10.938v1.874c0 1.036-.84 1.876-1.876 1.876h-1.874M7.813 5v2.813c0 .517-.42.937-.938.937h-.313M4.688 5L4.688 6.563M10.938 5L10.938 6.563M5.146 10.625c1.32 1.25 3.388 1.25 4.708 0",
    transform: "translate(1 1.107)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccess);
export default __webpack_public_path__ + "static/media/manage-access.acf76d0e7270f15ce4c4a9826b5f0405.svg";
export { ForwardRef as ReactComponent };